// Brand Colors: Reservika
// primary: #7F5BFF (freundlich, digital, modern)
// accent / secondary:  #5567FF  (warm, markant)
// background light: #F7F8FC
// background dark: #0F1117

export const common = {
  fonts: {
    body: `"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
    heading: `"Poppins", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif`,
    mono: `SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`,
  },

  font: {
    family: "Inter, sans-serif",
    size: "14px",
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
    }
  },

  fontWeights: {
    light: 300,
    normal: 400,
    semibold: 600,
    bold: 700,
  },

  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    xxl: "1.5rem",
  },

  lineHeights: {
    dense: 1.2,
    normal: 1.5,
    relaxed: 1.75,
    heading: 1.125,
  },

  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    xxl: "64px",
  },

  borderRadius: {
    sm: "6px",
    md: "10px",
    lg: "18px",
    pill: "9999px",
  },

  radius: {
    sm: "6px",
    md: "10px",
    lg: "14px",
  },

  shadow: {
    soft: "0 4px 20px rgba(0,0,0,0.08)",
    medium: "0 6px 28px rgba(0,0,0,0.12)",
  },

  boxShadow: {
    light: "0 1px 4px rgba(0,0,0,0.08)",
    default: "0 2px 8px rgba(0,0,0,0.08)",
    medium: "0 6px 16px rgba(0,0,0,0.12)",
    heavy: "0 12px 28px rgba(0,0,0,0.18)",
  },

  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    desktop: "1024px",
    largeDesktop: "1200px",
  },

  // 📱 Media Query Shortcuts
    mq: {
      mobile: '@media (max-width: 480px)',
      tablet: '@media (max-width: 768px)',
      desktop: '@media (max-width: 1024px)',
      largeDesktop: '@media (max-width: 1200px)',
    },

  sizes: {
    contentMaxWidth: "1800px",
    gutterMobile: "4px",
    gutter: "10px",
    gap: "64px",
  },

  transition: {
    default: "all 0.25s ease",
    fast: "all 0.15s ease",
  },

  opacity: {
    disabled: 0.55,
  },

  zIndex: {
    dropdown: 20,
    sticky: 30,
    fixed: 40,
    modalBackdrop: 50,
    modal: 60,
    popover: 70,
    tooltip: 80,
  },
};

export const lightTheme = {
  ...common,
  colors: {
    primary: "#5567FF",
    primaryHover: "#4353E6",
    secondary: "#7F5BFF",
    accent: "#7F5BFF",

    disabled: "#C9CBD1",

    text: "#F1F3F9",
    textSoft: "#B5B7C2",
    background: "#F7F8FC",
    surface: "#FFFFFF",

    border: "#E1E3EB",

    error: "#E5484D",
    danger: "#E5484D",
    dangerHover: "#C23439",

    success: "#32B768",
    warning: "#FFB020",
    info: "#3B82F6",

    focusOutline: "#5567FF",

    codeBg: "#FFF4DB",
    codeText: "#8A6534",

    // inputBg: "#FFFFFF",
    // inputBorder: "#D3D6DE",
    // inputBorderFocus: "#5567FF",
    // inputText: "#1A1A1F",
    // inputPlaceholder: "#9AA0B4",

    inputBg: 'rgba(255, 255, 255, 0.06)',
    inputBorder: 'rgba(255, 255, 255, 0.10)',
    inputBorderFocus: '#8B7CFF',

    inputText: '#F1F3F8',
    inputPlaceholder: 'rgba(241,243,248,0.45)',

    focusOutline: 'rgba(139,124,255,0.35)',

    grey: "#9CA3AF",
  },
};

// export const darkTheme = {
//   ...common,
//   colors: {
//     primary: "#5567FF",
//     primaryHover: "#7382FF",

//     accent: "#8F73FF",

//     disabled: "#444",

//     text: "#F1F3F9",
//     textSoft: "#B5B7C2",

//     background: "#0F1117",
//     surface: "#1A1D24",

//     border: "#2A2D36",

//     error: "#FF6B6F",
//     danger: "#FF6B6F",
//     dangerHover: "#E5484D",

//     success: "#3DDC97",
//     warning: "#FFC766",
//     info: "#58A6FF",

//     focusOutline: "#5567FF",

//     codeBg: "#1E1E1E",
//     codeText: "#FFD700",

//     inputBg: "#1A1D24",
//     inputBorder: "#333842",
//     inputBorderFocus: "#5567FF",
//     inputText: "#F1F3F9",
//     inputPlaceholder: "#8C91A0",

//     grey: "#6B7280",
//   },
// };
